// extracted by mini-css-extract-plugin
export default {"container":"TabsSwitch_container__dR+Gb","list":"TabsSwitch_list__k4NIJ","item":"TabsSwitch_item__7xWUW","active":"TabsSwitch_active__VARYy"};